import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { getLocalDate } from "utils/helpers";
import Responsive from "react-responsive";
import Carousel from "nuka-carousel";

import SpecialOffer from "components/SpecialOffer";
import ShowNewsModals from "components/ShowNewsModals";

import * as API from "api/news";
import * as offerAPI from "api/catalog";
import * as referalsAPI from "api/referals";

import OfficeImg from "img/pic____.png";
import AutoImg from "img/pic__2.png";
import CameraImg from "img/pic__3.png";
import MotorcycleImg from "img/pic__1.png";

const formatter = new Intl.NumberFormat("ru", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export interface INewsElement {
  id: number;
  name: string;
  description: string;
  image?: string;
  date_add?: string;
}

interface IModal {
  type: string;
  data?: INewsElement;
}

interface ILists {
  categories: any[];
  carClasses: any[];
  topOffers: any[];
}

const DashboardPage: React.SFC = () => {
  const currentPage = 0;

  const Desktop = (props: any) => <Responsive {...props} minWidth={992} />;
  const Tablet = (props: any) => (
    <Responsive {...props} minWidth={768} maxWidth={991} />
  );
  const Mobile = (props: any) => <Responsive {...props} maxWidth={767} />;

  const [isLoading, setLoading] = useState(false);
  const [agentsFee, setAgentsFee] = useState<any>(undefined);
  const [isEmptyReferalsList, checkReferalsList] = useState<boolean>(true);
  const [categories, setCategories] = useState<any | undefined>(undefined);
  const [modal, showModal] = useState<IModal | undefined>(undefined);
  const [news, setNews] = useState<{
    data: INewsElement[];
    pageCount: number;
    page: number;
  }>({ data: [], pageCount: 0, page: 0 });
  const [list, setList] = useState<ILists>({
    categories: [],
    carClasses: [],
    topOffers: []
  });

  const profit = agentsFee
    ? agentsFee.fee.orders_amount + agentsFee.ref_fee.orders_amount
    : 0;
  const myProfit =
    agentsFee && Math.round((agentsFee.fee.orders_amount / profit) * 100);

  const hideModal = () => showModal(undefined);

  const fetchNews = (page: number = 0, size: number = 2) => {
    setLoading(true);
    API.getNews(page, size)
      .then((response: any) => {
        if (response.success) {
          setNews(response);
        } else {
          toastr.error("Ошибка загрузки новостей", response.error);
        }
        setLoading(false);
      })
      .catch(e => setLoading(false));
  };

  useEffect(() => {
    offerAPI.getLists().then((response: any) => {
      if (response.success) {
        setList(response.data);
      } else {
        toastr.error("Ошибка получения данных", response.error);
      }
    });

    referalsAPI.getReferals().then((response: any) => {
      if (response.success) {
        checkReferalsList(!response.data.length);
      } else {
        toastr.error("Ошибка получения данных рефералов", response.error);
      }
    });

    referalsAPI.getAgentFee().then((response: any) => {
      if (response.success) {
        setAgentsFee(response.data);
      } else {
        toastr.error("Ошибка получения данных", response.error);
      }
    });

    offerAPI.dashboardCategories().then((response: any) => {
      if (response.success) {
        setCategories(response);
      } else {
        toastr.error("Ошибка получения данных", response.error);
      }
    });
  }, []);

  useEffect(
    () => {
      fetchNews(currentPage);
    },
    [currentPage]
  );

  return (
    <React.Fragment>
      <div className="container bug_1200">
        <div className="row bug_1200_row">
          <div className="col-xl-4 col-md-12 col-12  order-last order-xl-first">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="ref refbug___">
                  <div className="row">
                    <div className="col-12 col-md-6 col-xl-12">
                      <div className="row d-flex justify-content-between align-items-center no-gutters mb-3">
                        <h2 className="prof__title justify-content-between">
                          Мои показатели
                          <span className="d-md-none">{` ${getLocalDate(new Date(), "MMMM YYYY")}`}</span>
                        </h2>
                        <Link
                          to="/home/analytics"
                          className="prof__edit text-center"
                        >
                          Подробнее
                        </Link>
                      </div>
                      {agentsFee && (
                        <div className="d-md-flex justify-content-between col-12pl-0 pr-0">
                          <div className="green_price">
                            <small>Вы заработали:</small>
                            {/* {Math.round((agentsFee.fee.points  + agentsFee.ref_fee.points) * 100) / 100} */}
                            {formatter.format(agentsFee.fee.points  + agentsFee.ref_fee.points)}
                            <div className="atchivments__ top_g_____">
                              {formatter.format(agentsFee.fee.points)}{" "}
                              <span>– мой бонус</span>
                            </div>
                            {isEmptyReferalsList
                              ? null
                              : (
                                <div className="atchivments__">
                                  {formatter.format(agentsFee.ref_fee.points)}{" "}
                                  <span>– рефералы</span>
                                </div>
                              )
                            }
                          </div>
                          <div className="green_price black___">
                            <small>Продаж за месяц:</small>
                            {formatter.format(profit)} ₽
                            <div className="atchivments__ top_g_____">
                              {formatter.format(agentsFee.fee.orders_amount)}{" "}
                              <span>– мои продажи</span>
                            </div>
                            {isEmptyReferalsList
                              ? null
                              : (
                                <div className="atchivments__">
                                  {formatter.format(agentsFee.ref_fee.orders_amount)}{" "}
                                  <span>– рефералы</span>
                                </div>
                              )
                            }
                          </div>
                        </div>
                      )}

                      <div className="d-flex justify-content-between col-12pl-0 pr-0 options____">
                        <span>Прибыль</span>
                        <span className="gray_">
                          {isNaN(myProfit) ? 0 : myProfit + "%"} /{" "}
                          {isNaN(100 - myProfit) ? 0 : 100 - myProfit + "%"}
                        </span>
                      </div>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={myProfit}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: myProfit + "%" }}
                        />
                      </div>
                      <Link
                        to="/home/referal"
                        className="btn empty-btn p-0ptn___0_ ref-btn"
                      >
                        <strong className="w-100">Реферальная программа</strong>
                        <span className="w-100">
                          Пригласи друга и зарабатывай
                          <span className="d-block d-md-none" />
                          с его продаж
                        </span>
                      </Link>
                    </div>
                    <div className="col-12 col-md-6 col-xl-12 d-md-bloc">
                      <div className="row d-flex justify-content-between align-items-center no-gutters mb-2 mb-lg-3">
                        <h2 className="prof__title">Новости</h2>
                        <Link
                          to={"/home/news"}
                          className="prof__edit text-center"
                        >
                          Все новости
                        </Link>
                      </div>
                      {!isLoading && (
                        <div className="dashboard-new">
                          {news.data.map(item => {
                            if (item.image)
                              return (
                                <div
                                  key={item.id}
                                  className="news__block news_desc___"
                                >
                                  <div className="col-12 dashboard-news-date">
                                    <span>
                                      {getLocalDate(
                                        item.date_add,
                                        "DD.MM.YYYY"
                                      )}
                                    </span>
                                  </div>
                                  <img
                                    src={item.image}
                                    alt=""
                                    className="news__block-img mb-2"
                                    style={{ display: "none" }}
                                  />
                                  <div className="row align-items-center">
                                    <div
                                      onClick={() =>
                                        showModal({
                                          type: "showImage",
                                          data: item
                                        })
                                      }
                                      className="col-12 col-md-10 cursor-pointer"
                                    >
                                      <h3 className="news__block-title">
                                        {item.name}
                                      </h3>
                                    </div>
                                    <div
                                      className="col-12"
                                      onClick={() =>
                                        showModal({
                                          type: "showImage",
                                          data: item
                                        })
                                      }
                                    >
                                      <p className="news__block-text">
                                        {item.description.slice(0, 100)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            return (
                              <div
                                key={item.id}
                                className="news__block news_desc___"
                              >
                                <div className="col-12 dashboard-news-date">
                                  <span>
                                    {getLocalDate(item.date_add, "DD.MM.YYYY")}
                                  </span>
                                </div>
                                <div className="row">
                                  <div
                                    onClick={() =>
                                      showModal({ type: "show", data: item })
                                    }
                                    className="col-12 col-md-10 cursor-pointer"
                                  >
                                    <h3 className="news__block-title">
                                      {item.name}
                                    </h3>
                                  </div>
                                  <div
                                    className="col-12"
                                    onClick={() =>
                                      showModal({ type: "show", data: item })
                                    }
                                  >
                                    <p className="news__block-text">
                                      {item.description.slice(0, 100)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-8 order-first order-xl-last">
            <div className="container-fluid px-0">
              <div className="row mx-0">
                <Link
                  to={`/home/catalog/page/0?${categories && categories[0].id_cat ? `category=${categories[0].id_cat}` : ''}`}
                  className="col-12 col-md-6 pl-md-0 pr-md-1 px-0"
                >
                  <div
                    className="preview_"
                    style={{ backgroundImage: `url(${AutoImg})` }}
                  >
                    <span>{categories && categories[0].name_base_cat}</span>
                  </div>
                </Link>
                <Link
                  to={`/home/catalog/page/0?${categories && categories[1].id_cat ? `category=${categories[1].id_cat}` : ''}`}
                  className="col-12 col-md-6 pl-md-0 pr-md-1 px-0"
                >
                  <div
                    className="preview_"
                    style={{ backgroundImage: `url(${OfficeImg})` }}
                  >
                    <span>{categories && categories[1].name_base_cat}</span>
                  </div>
                </Link>
                <Link
                  to={`/home/catalog/page/0?${categories && categories[2].id_cat ? `category=${categories[2].id_cat}` : ''}`}
                  className="col-12 col-md-6 pl-md-0 pr-md-1 px-0"
                >
                  <div
                    className="preview_"
                    style={{ backgroundImage: `url(${CameraImg})` }}
                  >
                    <span>{categories && categories[2].name_base_cat}</span>
                  </div>
                </Link>
                <Link
                  to={`/home/catalog/page/0?${categories && categories[3].id_cat ? `category=${categories[3].id_cat}` : ''}`}
                  className="col-12 col-md-6 pl-md-0 pr-md-1 px-0"
                >
                  <div
                    className="preview_"
                    style={{ backgroundImage: `url(${MotorcycleImg})` }}
                  >
                    <span>{categories && categories[3].name_base_cat}</span>
                  </div>
                </Link>
              </div>
              <div className="row mx-0 offer-slider">
                <Desktop>
                  <Carousel slidesToShow={3} dragging={true}>
                    {list.topOffers.map(item => (
                      <SpecialOffer {...item} key={`item-${item.id}`} />
                    ))}
                  </Carousel>
                </Desktop>
                <Tablet>
                  <Carousel slidesToShow={2} dragging={true}>
                    {list.topOffers.map(item => (
                      <SpecialOffer {...item} key={`item-${item.id}`} />
                    ))}
                  </Carousel>
                </Tablet>
                <Mobile>
                  <Carousel slidesToShow={1} dragging={true}>
                    {list.topOffers.map(item => (
                      <SpecialOffer {...item} key={`item-${item.id}`} />
                    ))}
                  </Carousel>
                </Mobile>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <ShowNewsModals
          type={modal.type}
          data={modal.data}
          onClose={hideModal}
        />
      )}
    </React.Fragment>
  );
};

export default DashboardPage;
